import { configureStore } from "@reduxjs/toolkit";
import reducers from "./reducers";
import { persistStore } from "redux-persist";
import cartSyncMiddleware from "./middleware/cartSyncMiddleware";
import cartAdditionMiddleware from "./middleware/cartAdditionMiddleware";

const store = configureStore({
  reducer: reducers,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).prepend(cartAdditionMiddleware, cartSyncMiddleware.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

const persistor = persistStore(store);

export { store, persistor };
